import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesRight } from "@fortawesome/free-solid-svg-icons";
import { useEffect } from "react";
import Bizpetroimg from "./../../assets/bizpetro.avif";
import Aos from "aos";
import "aos/dist/aos.css";
import "./Products.css";

function Bizpetro() {
  useEffect(() => {
    Aos.init({
      duration: 1000,
      offset: 300,
    });
  }, []);

  return (
    <div className="container my-5 py-5 z-depth-1">
      <section className="px-md-5 mx-md-5 dark-grey-text text-center text-lg-left">
        <div className="row">
          <div
            className="col-lg-6 mb-4 mb-lg-0 d-flex align-items-center justify-content-center  "
            data-aos="fade-right"
          >
            <img
              src={Bizpetroimg}
              className="img-fluid  shadow   bg-body "
              alt="Petrol Pump Software BizPetro Fuel Station Management System"
            />
          </div>

          <div className="col-lg-6 mb-4 mb-lg-0" data-aos="fade-left">
            <h3 className="font-weight-bold">
              {/* Bizpetro Your Trusted Energy Partner */}
              BizPetro Petrol Pump Management Software
            </h3>

            <p className="font-weight-bold">
               Complete Fuel Station & Petrol Pump Software Solution
            </p>
            <p className="text-muted Text-in-Trusted">
               BizPetro is an advanced and best petrol pump management software designed to automate
  and streamline fuel station operations. Our system helps petrol pump owners
  manage billing, fuel sales, petrol pump inventory, and daily transactions efficiently.
  
  With our fuel station automation software, businesses can track fuel stock,
  monitor sales in real-time, and generate accurate reports for better decision-making.
  BizPetro which is the best petrol pump software ensures smooth operations, reduces manual errors, and improves overall
  efficiency in petrol pump management.

  Whether you run a single fuel station or multiple outlets, our petrol pump
  software provides a scalable and reliable solution for modern energy businesses.
            </p>

            <a
              className="font-weight-bold"
              href="https://bizpetro.com/"
              target="blank"
            >
              Learn more
              <FontAwesomeIcon className="arrow-icon" icon={faAnglesRight} />{" "}
              <i className="fas fa-angle-right ml-2"></i>
            </a>
             {/* <div className="download-button-div">
  <button
    className="download-button"
    onClick={() =>
      window.open("/Bizpetro%20Leaflet%20growbean%20.pdf", "_blank")
    }
  >
   Bizpetro Product Guide
  </button>
</div> */}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Bizpetro;
